var map = {
	"./bottom-center.png": 74381,
	"./bottom-left.png": 77537,
	"./bottom-right.png": 68042,
	"./center-left.png": 3835,
	"./center-right.png": 79940,
	"./center.png": 70653,
	"./top-center.png": 23907,
	"./top-left.png": 27151,
	"./top-right.png": 42304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43709;